import Config from "@/const/Config";
import { Shinsei, ShinseiList, ListSearchForm, ShinseiDetailRes, ZanYuukyuuRes, ZanFurikyuuRes, ApprovalData } from "@/types/Shinsei";
import { BaseApi } from "./BaseApi";
import { Flow } from "@/types/SyouninGroup";
import { ShinseiOption } from "@/types/Option";

export class ShinseiApi extends BaseApi {

  /**
   * 新規登録をします
   * @param params
   * @returns
   */
  public async create(params: Shinsei): Promise<Shinsei> {
    try {
      const res = await this.post(Config.API_URL + `/shinsei`, params);
      return res.data as Shinsei;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 再申請します
   * @param params
   * @returns
   */
  public async again(params: Shinsei): Promise<number> {
    try {
      const res = await this.post<number>(Config.API_URL + `/shinsei/again`, params);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 取消を行います
   * @param shinseiId
   * @returns
   */
  public async cancel(shinseiId: number): Promise<Shinsei> {
    try {
      const req = {
        shinseiId: shinseiId
      }
      const res = await this.post(Config.API_URL + `/shinsei/cancel`, req);
      return res.data as Shinsei;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 一覧を取得します
   * @param params
   * @returns
   */
  public async list(params: ListSearchForm): Promise<ShinseiList[]> {
    try {
      const res = await this.post(Config.API_URL + `/shinsei/list`, params);
      return res.data as ShinseiList[];
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 申請情報を取得します
   * @param id
   * @param type
   * @returns
   */
  public async info(id: number): Promise<ShinseiDetailRes> {
    try {
      const req = {
        shinseiId: id
      }
      const res = await this.post(Config.API_URL + `/shinsei/detail`, req);
      return res.data as ShinseiDetailRes;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 特定の承認処理を行います
   * @param params
   * @returns
   */
  public async approval(params: Shinsei): Promise<Flow[]> {
    try {
      const res = await this.post(Config.API_URL + `/shinsei/approval`, params);
      return res.data as Flow[];
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 申請に関するオプションを取得します
   * @param path
   * @returns
   */
  public async getShinseiOption(): Promise<ShinseiOption> {
    try {
      const res = await this.get<ShinseiOption>(Config.API_URL + `/shinsei/options/all`)
      return res.data
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 確認者による承認を行います
   * @returns
   */
  public async checkForConfUser(params: ApprovalData): Promise<Flow[]> {
    try {
      const res = await this.post<Flow[]>(Config.API_URL + `/shinsei/check`, params);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 確認者による承認を行います
   * @returns
   */
    public async zanYuukyuu(userIdList: number): Promise<ZanYuukyuuRes> {
    try {
      const req = {
        userId: userIdList
      }
      const res = await this.post<ZanYuukyuuRes>(Config.API_URL + `/shinsei/zanyuukyuu_conunt`, req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 未取得の振出日数を取得します
   * @returns
   */
    public async getZanFurikyuuCount(userId: number, koyouKeiyakuId?: number): Promise<ZanFurikyuuRes | null> {
      try {
        const req: { userId: number; koyouKeiyakuId?: number } = { userId };
        if (koyouKeiyakuId !== undefined) req.koyouKeiyakuId = koyouKeiyakuId;
        const res = await this.post<ZanFurikyuuRes | null>(Config.API_URL + `/shinsei/zanfurikyuu_count`, req);
        return res.data;
      } catch (e: any) {
        throw e;
      }
    }
}
